import { previewPatientFax } from '@lotushealth/lotushealth_js_sdk/endpoints';
import type { FaxBuildRequestT } from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

import type { DocumentDraft } from '../model/documentDraftTypes';
import { documentRecipientFromMarkdown, documentTitleFromMarkdown } from './documentMarkdown';

/** Render a draft with the fax PDF builder, which every document channel previews with. */
export async function previewDocumentPdf(
  patientId: string,
  draft: DocumentDraft,
  signal: AbortSignal
): Promise<Blob> {
  const config = await createLotusRequestConfig({ signal });
  const recipient = documentRecipientFromMarkdown(draft.content.bodyMarkdown);
  const request: FaxBuildRequestT = {
    title: documentTitleFromMarkdown(draft.content.bodyMarkdown),
    header_markdown: null,
    recipient: {
      name: recipient.name,
      organization: recipient.organization || null,
      fax_number: recipient.faxNumber,
    },
    attachments: draft.content.attachments.map(({ attachmentId }) => ({
      attachment_id: attachmentId,
    })),
    body_markdown: draft.content.bodyMarkdown.trim() || ' ',
    filename: 'document-preview.pdf',
  };
  const response = await previewPatientFax(patientId, request, {
    ...config,
    responseType: 'blob',
  });
  if (!(response.data instanceof Blob)) {
    throw new Error('The document preview was not a PDF.');
  }
  return response.data;
}
